import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Payer } from '../../model/payer';
import { FormGroup } from '@angular/forms';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { BankTransactionImportService } from '../../service/data/bank-transaction-import.service';
import { BankTransactionImport, BankTransactionStatus } from '../../model/bank-transaction-import';

@Component({
    selector: 'app-change-bank-transaction-status-form',
    templateUrl: './change-bank-transaction-status-form.component.html',
    styleUrls: ['./change-bank-transaction-status-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeBankTransactionStatusFormComponent implements OnInit {
  infoText: string;
  title: string;

  constructor(
    private _dialogService: ActionWindowService,
    private _bankTransactionImportService: BankTransactionImportService
  ) {}

  @Input() dataContext: any;

  readonly form: FormGroup;
  payers: Payer[];

  cancel() {
    this._dialogService.close();
  }

  ngOnInit() {
    if (this.dataContext.bankTransactionStatus == BankTransactionStatus.Ignored) {
      this.title = 'BANK_IMPORT_TRANSACTIONS.IGNORE_BANK_TRANSACTION';
      this.infoText = 'BANK_IMPORT_TRANSACTIONS.IGNORE_BANK_TRANSACTION_INFO';
    }
    if (this.dataContext.bankTransactionStatus == BankTransactionStatus.Unhandled) {
      this.title = 'BANK_IMPORT_TRANSACTIONS.UNDO_IGNORED_HEADER';
      this.infoText = 'BANK_IMPORT_TRANSACTIONS.UNDO_IGNORE_BANK_TRANSACTION_INFO';
    }
  }

  onSubmit() {
    let commandContext: BankTransactionImport = this.dataContext.commandContext;

    const update$ = commandContext
      ? this._bankTransactionImportService.updateBankTransactionStatus(commandContext, this.dataContext.bankTransactionStatus)
      : this._bankTransactionImportService.updateBankTransactionStatusFiltered(
          this.dataContext.filter,
          this.dataContext.includedIds,
          this.dataContext.excludedIds,
          this.dataContext.affectedItemsCount,
          this.dataContext.bankTransactionStatus
        );

    update$.subscribe(bankTransaction => {
      this._dialogService.complete(bankTransaction);
    });
  }
}
